export const formatCurrency = (value: string | number): string => {
  const numVal = Number(value);
  if (!isNaN(numVal)) {
    return `₹ ${numVal.toLocaleString('en-IN')}`;
  }

  return `₹ ${value}`;
};

export const formatPercentage = (value: string | number): string => {
  return `${value}%`;
};

export const formatDate = (isoString: string): string => {
  if (!isoString) return '';
  const d = new Date(isoString);
  if (isNaN(d.getTime())) return isoString;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();

  return `${dd}-${mm}-${yyyy}`;
};

export const formatBoolean = (value: string | boolean): any => {
  const strVal = String(value).toLowerCase();
  if (strVal === 'yes' || strVal === 'true')
    return {text: 'Yes', color: 'green', bold: true};
  if (strVal === 'no' || strVal === 'false')
    return {text: 'No', color: 'red', bold: true};

  return {text: String(value)};
};

export const formatDateRange = (value: string): string => {
  try {
    const rangeObj = JSON.parse(value);

    return `📅 ${formatDate(rangeObj.start)} → ${formatDate(rangeObj.end)}`;
  } catch (e) {
    return `📅 ${value}`;
  }
};

/**
 * Returns a hex color code for a given framework name.
 * Add new frameworks to FRAMEWORK_COLORS without touching any other code.
 */
export function getFrameworkColor(framework: string): string {
  const FRAMEWORK_COLORS: Record<string, string> = {
    brsr: '4285f4',
    gri: '34a853'
  };

  return FRAMEWORK_COLORS[framework?.toLowerCase()] ?? 'fbbc04';
}

export const romanize = (num: number): string => {
  if (isNaN(num) || num <= 0) return '';

  // Standard Roman Numeral mapping in descending order
  // This logic handles 1 through 3999 easily.
  const lookup: Record<string, number> = {
    m: 1000,
    cm: 900,
    d: 500,
    cd: 400,
    c: 100,
    xc: 90,
    l: 50,
    xl: 40,
    x: 10,
    ix: 9,
    v: 5,
    iv: 4,
    i: 1
  };

  let roman = '';
  let n = num;

  for (const key in lookup) {
    while (n >= lookup[key]) {
      roman += key;
      n -= lookup[key];
    }
  }

  return roman;
};

export const alphaFormat = (num: number): string => {
  if (num <= 0) return '';
  let result = '';
  let n = num;
  while (n > 0) {
    const remainder = (n - 1) % 26;
    result = String.fromCharCode(97 + remainder) + result;
    n = Math.floor((n - 1) / 26);
  }

  return result;
};

export const formatPageNumber = (index: number, format: string): string => {
  const num = index + 1;
  switch (format) {
    case 'abc':
    case 'alpha':
      return alphaFormat(num);
    case 'roman':
    case 'i-ii-iii':
      return romanize(num);
    default:
      return String(num);
  }
};
